<template>
    <div class="fill inventory-scan-container">
        <div v-if="qrCodeBase64" class="qr-code">
            <img :src="'data:image/png;base64,' + qrCodeBase64" alt="二维码" />
        </div>
        <div class="instruction">
            用扫码枪扫描以开始盘库
        </div>
    </div>
</template>

<script>
export default {
    name: "stocktakeQrCode",
    data() {
        return {
            qrCodeBase64: "", // 存储二维码Base64
        };
    },
    created() {
        this.setVisible(false);
    },
    mounted() {
        this.fetchQRCode(this.$route.query.taskId);
        this.onInfinite()
        this.activeName = Number.parseInt(this.$route.query.taskId + '');
        // this.activeName = JSON.parse(localStorage['url_return_json']).state;
    },
    beforeDestroy() {
        this.setVisible(true);
    },
    methods: {
        setVisible(visibility) {
            this.$store.commit("base/setShowHeader", visibility, {root: true});
            this.$store.commit("base/setShowSidebar", visibility, {root: true});
        },
        async fetchQRCode(taskId) {
            try {
                this.loading = true;
                await this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_EM_ARCHIVE_URL + "/emStocktakingTask/generateTaskQrCode?taskId="+taskId
                }).then(response => {
                    if (response && response.data) {
                        this.$message.success("生成任务二维码成功");
                        this.qrCodeBase64=response.data;
                    }
                })
            } finally {
                this.loading = false;
            }
        },
    }
};
</script>

<style scoped>
.inventory-scan-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
}

.qr-code img {
    width: 200px;
    height: 200px;
    border: 1px solid #ccc;
}

.instruction {
    margin-top: 20px;
    font-size: 18px;
    color: #333;
}
.fill {
    width: 100%;
    height: 100%;
}

.fill >>> .el-collapse-item__content {
    padding-bottom: 0;
}

.fill-w {
    width: 100%;
}

.fill-h {
    height: 100%;
}
</style>
